<template>
  <div class="wantList-container">
    <b-row class="mt-4">
                <b-col>
                    <want-list-menu :selected="selected"
                                    :rowCount="items.length"
                                    @selectAll="$refs.customerWantListTable.selectAllRows()"
                                    @clearSelected="$refs.customerWantListTable.clearSelected()"
                                    @removeFromWants="removeFromWants()"
                                    @setSelectRange="setSelectRange()">
                    </want-list-menu>
                              
                </b-col>
                <b-col>
                    <want-list-item-search :wantList="itemIds" @removeFromWants="removeFromWants" @addToWants="addToWants"></want-list-item-search>
                </b-col>
            </b-row>
      <div class="scrollable-container">
          <b-table primary-key="item" sticky-header small no-border-collapse
                  selectable
                   @row-selected="rowSelected"
                   class="wantList-table"
                   :items="items"
                   :fields="fields"
                   :busy.sync="isBusy"
                   ref="customerWantListTable"
                   id="customerWantListTable"
                   caption-top>
              <template #cell(itemId)="row">
                  <b-link :to="{ name: 'itemDetails', params: { outsideQuery: { query: row.value.toString(), filters: {} } } }" append >{{ row.value }}</b-link>
              </template>

              <template #cell(artist)="data">
                  <span v-html="artistData(data)"></span>
              </template>

              <template #cell(title)="data">
                  <span v-html="titleData(data)"></span>
              </template>

              <template #cell(label)="data">
                  <span v-html="labelData(data)"></span>
              </template>

              <template #cell(genre)="data">
                  <ul class="p-0 d-flex flex-column">
                      <li class="cellListItem list-unstyled" v-for='(genre, index) in data.item.release.genres' :key='index'>
                      {{genre.name}}
                      </li>
                  </ul>
              </template>

              <template #cell(format)="data">
                  <span v-html="format(data)"></span>
              </template>

              <template #cell(pressing)="data">
                  <span class='d-flex' v-html="pressingData(data.item.release.pressing)"></span>
              </template>

              <template #cell(media)="data">
                  <span v-html="mediaData(data.item.release.media)"></span>
              </template>

              <template #cell(active)="data">
                  <span>{{ data.item.listing.count }}</span>
              </template>

              <template #cell(inactive)="data">
                  <span>{{ inactiveCount(data.item) }}</span>
              </template>

              <template #cell(location)="data">
                  {{ data.item.listing.location }}
              </template>

              <template #cell(price)="data">
                  <span class="text-success">${{ data.item.listing.price }}</span>
              </template>


              <template #cell(grade)="data">
                  <span class='cellListItem d-inline-block' v-html="gradeData(data.item.listing.condition)"></span>
              </template>

              <template #table-busy>
                  <div class="text-center my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong class="mx-3">Loading...</strong>
                  </div>
              </template>

          </b-table>
      </div>
  </div>
</template>

<script>
  import searchMixin from "../../mixins/search";
  import inventoryApi from "../../api/inventory";
  import customerApi from "../../api/customers";
  import utils from "../../mixins/utils";
  import WantListMenu from "./WantListMenu";
  import WantListItemSearch from './WantListItemSearch';

  export default {
      name: "CustomerWantList",
      components: { WantListMenu, WantListItemSearch },
      mixins: [ searchMixin, inventoryApi, customerApi, utils ],
      props: [ 'customerId', "email" ],
      watch: {
        customerId: {
          immediate: true,
          handler(newCustomerId) {
            if (newCustomerId) {
              this.fetchWantListItems();
            }
          },
       },
      },
      data() {
          return {
              wantListId: null,
              searchText: '',
              searchResults: {},
              itemIds: [],
              items: [],
              selected: [],
              numItems: 0,
              currentPage: 1,
              perPage: 100,
              isBusy: false,
              fields: [
                  { key: 'itemId', label: 'Item' },
                  { key: 'artist', label: 'Artist' },
                  { key: 'title', label: 'Title' },
                  { key: 'label', label: 'Label' },
                  { key: 'genre', label: 'Genre'},
                  { key: 'format', label: 'Format' },
                  { key: 'active', label: 'Active' },
                  { key: 'inactive', label: 'Inactive' },
                  { key: 'price', label: '$'},
                  { key: 'grade', label: 'Grade'},
                  { key: 'location', label: 'Location' },
                  { key: 'pressing', label: 'Pressing' },
                  { key: 'media', label: 'Media' },
              ],
              numOrders: 0,
          }
      },

      methods: {
        async fetchWantListItems() {
            try {
                this.isLoading = true;
                const fetchedWantLists = await this.getCustomerWantlist(this.customerId);

                // Check if fetchedWantLists is an empty object
                if (Object.keys(fetchedWantLists).length === 0) {
                    this.wantListId = null;
                    this.itemIds = [];
                    this.items = [];
                    return;
                }

                const firstEmail = Object.keys(fetchedWantLists)[0];
                const customerData = fetchedWantLists[firstEmail];

                // Check if customerData is null or undefined
                if (!customerData) {
                    this.wantListId = null;
                    this.itemIds = [];
                    this.items = [];
                    return;
                }

                this.wantListId = customerData._id || null;
                const combinedItemIds = customerData.itemIds || [];
                this.itemIds = combinedItemIds;

                let joinedIds = this.itemIds.join(',');
                let results = await this.searchItems({ itemIds: joinedIds });
                this.numItems = results.totalDocs;
                this.items = results.docs;
            } catch (error) {
                console.error('Error fetching want lists:', error);
                // Handle the error, e.g., show an error message to the user
            } finally {
                this.isLoading = false;
            }
        },
        async addToWants(idArray = []) {
            try {           
                await this.addWants(this.wantListId, idArray, this.email);
                await this.fetchWantListItems();
                console.log('Items removed from wants successfully.');
            } catch (error) {
                console.error('Error removing items from wants:', error);
            }
            
        },
        async removeFromWants(idArray = null) {
            let itemArray;
            if (idArray) {
                itemArray = idArray;
            } else {
                itemArray = this.selected.map(item => item.itemId);
            }
            try {
                if (!this.wantListId) {
                    console.error("No wantListId available.");
                    return;
                }          
                await this.removeWants(this.wantListId, itemArray);
                this.selected = [];
                await this.fetchWantListItems();
                console.log('Items removed from wants successfully.');
            } catch (error) {
                console.error('Error removing items from wants:', error);
            }
        },
        rowSelected(rows) {
        this.selected = rows;
        },
        updateNumOrders(num) {
            this.numOrders = num;
        },
        parseSearchResults(results) {
            for (let i = 0; i < results.length; i++) {
                if (results[i].listing.offsite) {
                    results[i]['_rowVariant'] = 'warning';
                }
            }
            return results;
        },
        artistData(data) {
            return `${this.artist(data)}`;
        },
        titleData(data) {
            return `${this.title(data)}`;
        },
        release(data) {
            return `${this.artist(data)}: ${this.title(data)}`;
        },
        labelData(data) {
            return `${this.label(data)} ${this.catalogNo(data)}`;
        },
        pressingData(data) {
            return data.map(p => {
                return p.text
            }).join(', ');
        },
        mediaData(data) {
            return data.map(media => {
                return media.attributes;
            }).join(', ');
        },
        gradeData(conditionArray) {
            if (conditionArray.length < 1) return '';
            const sortOrder = ["item", "disc", "cassette", "cover", "case", "label", "insert"];
            const sortedArray = conditionArray.slice().sort((a, b) => sortOrder.indexOf(a.subject) - sortOrder.indexOf(b.subject));
            return sortedArray.map(condition => {return condition.grade}).join(', ');
        },
        format(data, separator = ' ') {
            if (!data.item.release.media.length || !data.item.release.media[0].size) {
                return ``;
            }

            if (data.item.release.media[0].size === '12') {
                if (data.item.release.media[0].duration === 'Single') {
                    return '12'
                } else if (data.item.release.media[0].duration === 'LP') {
                    return 'LP';
                } else {
                    return data.item.release.media[0].duration;
                }
            } else if (data.item.release.media[0].size === '10') {
                if (data.item.release.media[0].speed === '78') {
                    return '78';
                }
                return '10';
            } else if (data.item.release.media[0].size === '7') {
                if (data.item.release.media[0].duration === 'EP') {
                    return 'EP'
                } else {
                    return '45';
                }
            } else if (data.item.release.media[0].size === '5') {
                return 'CD';
            } else if (data.item.release.media[0].size === '4') {
                return 'Cassette';
            }

            if (data.item.release.media.length) {
                let size = data.item.release.media[0].size;
                let count = data.item.release.media[0].count;

                if (count > 1) {
                    size = `${count}x${size}`;
                }

                let format = `${size}" ${data.item.release.media[0].duration}`;

                format += separator;

                if (data.item.release.media[1]) {
                    format += `...`;
                }

                return format;
            }
        },
        artist(data) {
            if (!data.item.release.artist) {
                return ``;
            }

            if (data.item.release.artist.first) {
                return `${data.item.release.artist.first} ${data.item.release.artist.last}`.trim();
            }

            return `${data.item.release.artist.last}`.trim();
        },
        title(data) {
            if (data.item.release.titles && data.item.release.titles[0] && data.item.release.titles[1]) {
                return `${data.item.release.titles[0]} / ${data.item.release.titles[1]}`;
            }

            return data.item.release.titles[0] || '';
        },
        label(data) {
            if (data.item.release.label && data.item.release.label.name) {
                return `${data.item.release.label.name}`;
            }

            return '';
        },
        catalogNo(data) {
            if (data.item.release.label && data.item.release.label.catalogNo) {
                return `${data.item.release.label.catalogNo}`;
            }

            return '';
        },
        inactiveCount(item) {
            if (!item.counts || !item.counts.inactive) {
                return 0;
            }

            return item.counts.inactive.count;
        },
        priceTotal(data) {
            let price = 0;

            data.items.forEach(item => {
                if (!isNaN(item.listing.price)) {
                    price += item.listing.price;
                }
            });

            return price.toLocaleString();
        },
        activeTotal(data) {
            let active = 0;

            data.items.forEach(item => {
                if (item.listing.type === 'active' && !isNaN(item.listing.count)) {
                    active += item.listing.count;
                }
            });

            return active;
        },
        inactiveTotal(data) {
            let inactive = 0;

            data.items.forEach(item => {
                if (item.counts.inactive && !isNaN(item.counts.inactive.count)) {
                    inactive += item.counts.inactive.count;
                }
            });

            return inactive;
        
        },
        itemLink(item) {
            this.$router.push({ name: 'inventory', params: { outsideQuery: { query: item.id } } })
        },
        }
      }

</script>

<style scoped>


  .wantList-table {
      max-height: calc(100% - 20px);
      box-sizing: border-box;
  }

  .wantList-container {
      display: flex;
      flex-direction: column;
      height: calc(100vh - 200px);
      box-sizing: border-box; 
  }

  .scrollable-container {
      overflow: auto;
      flex-grow: 1;
  }

  .cellListItem {
      width: max-content;
      padding-right: 10px;
  }


</style>